import { all, fork } from 'redux-saga/effects';
import { watchReportedErrors } from './errorSagas';
import { applyInitialLanguage, watchSetLanguage } from './languageSagas';

export function* rootSaga() {
  yield all([
    fork(watchReportedErrors),
    fork(applyInitialLanguage),
    fork(watchSetLanguage),
  ]);
}
